import { useEffect, useState } from "react";
import { Button, Container, Divider, Group, Table, Text } from "@mantine/core";
import { useUser } from "../tools/Context";
import { get } from "./Request";

export default function DisplayDecompteProof({ decompteId }) {
  const user = useUser();
  const [decompte, setDecompte] = useState(null);
  const [signers, setSigners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDecompte = async () => {
      try {
        const result = await get(`decompte/${decompteId}`, null, user.token);
        setDecompte(result.decompte);
        setSigners(result.signers);
      } catch (err) {
        console.error("Error fetching decompte:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDecompte();
  }, [decompteId, user.token]);

  if (loading) return <Container>Chargement...</Container>;

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString("fr-FR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Container size="md">
      <Group justify="space-between">
        <Text>
          {decompte.name} {decompte.os_name}
        </Text>
        <Group>
          {decompte.document_linked_proof && user.role === "administrateur" && (
            <Button
              component="a"
              color="#0a0082"
              href={`${process.env.REACT_APP_DATALOCK_URL_WEB}proof?uid=${decompte.document_linked_proof}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Voir la preuve
            </Button>
          )}
        </Group>
      </Group>
      <Divider mt={15} mb={15}></Divider>

      <Table striped highlightOnHover withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Utilisateur</Table.Th>
            <Table.Th>Rôle</Table.Th>
            <Table.Th>Action</Table.Th>
            <Table.Th>Date</Table.Th>
            <Table.Th>Statut</Table.Th>
            <Table.Th>Commentaire</Table.Th>
            {user.role === "administrateur" && <Table.Th>Preuve</Table.Th>}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {signers.map((signer, index) => (
            <Table.Tr key={index}>
              <Table.Td>{signer.email}</Table.Td>
              <Table.Td>{signer.user_role}</Table.Td>

              <Table.Td>{signer.role === "signer" ? "Signataire" : "Lecteur"}</Table.Td>
              <Table.Td>{signer.signed_at ? formatDate(signer.signed_at) : ""}</Table.Td>
              <Table.Td>
                <Table.Td>
                  {signer.role !== "signer"
                    ? ""
                    : signer.status === "approved"
                    ? "Approuvé"
                    : signer.status === "rejected"
                    ? "Rejeté"
                    : signer.status === "reserved"
                    ? "Réservé"
                    : "En attente"}
                </Table.Td>
              </Table.Td>
              <Table.Td>{signer.comment || ""}</Table.Td>
              {signer.signed_at && user.role === "administrateur" ? (
                <Table.Td>
                  <Button
                    component="a"
                    color="#0a0082"
                    href={`${process.env.REACT_APP_DATALOCK_URL_WEB}proof?uid=${signer.cepaj_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Voir la preuve
                  </Button>
                </Table.Td>
              ) : (
                <Table.Td></Table.Td>
              )}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
}
